import classNames from "classnames"
import ApplicationComponent from "legacy/ApplicationComponent"
import PropTypes from "prop-types"
import React from "react"

import Modal from "src/components/Modal"

// Note: jQuery ($) is loaded globally
// Note: Amplitude is loaded globally

class ContractQuoteV2Actions extends ApplicationComponent {
  constructor(args) {
    super(args)
    this.state = { showModal: false, saving: false, dropdownShown: false }
    this.openModal = this.openModal.bind(this)
    this.closeModal = this.closeModal.bind(this)
    this.sendContract = this.sendContract.bind(this)
    this.toggleDropdown = this.toggleDropdown.bind(this)
    this.bodyClickEvent = this.bodyClickEvent.bind(this)
    this.markContractDeclined = this.markContractDeclined.bind(this)
    this.closeDropdown = this.closeDropdown.bind(this)
    this.openDropdown = this.openDropdown.bind(this)
    this.dropdown = null
    this.setDropdownRef = (element) => {
      this.dropdown = element
    }
  }

  bodyClickEvent(event) {
    // If a click happens inside the dropdown ref, do NOT close the dropdown
    // If a click happens outside the dropdown ref, close the dropdown
    if (this.dropdown && !this.dropdown.contains(event.target)) {
      this.closeDropdown()
    }
  }

  toggleDropdown() {
    this.state.dropdownShown ? this.closeDropdown() : this.openDropdown()
  }

  openDropdown() {
    this.setState({ dropdownShown: true })
    document.body.addEventListener("click", this.bodyClickEvent)
  }

  closeDropdown() {
    this.setState({ dropdownShown: false })
    document.body.removeEventListener("click", this.bodyClickEvent)
  }

  openModal() {
    this.setState({ showModal: true })
  }

  closeModal() {
    this.setState({ showModal: false })
  }

  sendContract() {
    this.setState({ saving: true })
    this.props.markRowSending(true)

    $.post(`${this.props.sendUrl}`, null, ({ success, response }) => {
      if (success === true) {
        this.trackSentContract()
      } else {
        // If the send failed, the actions menu should be re-enabled; otherwise we want to force them to refresh
        this.props.markRowSending(false)
        this.setState({ saving: false })
      }

      if (this.props.updateSendContractFlash) {
        this.props.updateSendContractFlash({ success, response })
      }
    })
      .fail((error) => {
        console.error(error)
        this.props.markRowSending(false)
        this.setState({ saving: false })
      })
      .always(() => {
        this.closeModal()
      })
  }

  markContractDeclined() {
    this.setState({ saving: true })

    $.patch(`${this.props.markContractDeclinedUrl}`)
      .then((response) => {
        this.setState({ saving: false })
        alert(response.message)
      })
      .fail((error) => {
        console.error(error)
        this.setState({ saving: false })
      })
  }

  trackSentContract() {
    const attributes = { contract_quote_id: this.props.quote.encodedId }
    if (this.props.quote.status === "Sent") {
      attributes.resend = true
    }
    attributes.marina_id = this.props.marina.slug
    attributes.marina_name = this.props.marina.name
    Amplitude.trackEvent("contracts:sent", attributes)
  }

  sendButtonTitle() {
    return this.props.quote.status === "Sent" ? "Resend" : "Send"
  }

  isCompleted() {
    return ["Signed", "Completed In House", "Canceled"].includes(
      this.props.quote.status
    )
  }

  isDeclined() {
    return ["Voided", "Boater Declined"].includes(this.props.quote.status)
  }

  actionsList(className = null) {
    const actions = []
    if (this.isCompleted()) {
      actions.push(
        <a
          key="reservation"
          className={
            className ||
            "block rounded-sm bg-transparent px-3 py-1 text-left text-black no-underline hover:bg-blue-50 hover:text-blue-700"
          }
          href={this.props.reservationUrl}
        >
          Contract
        </a>
      )
    } else if (this.isDeclined()) {
      actions.push(
        <a
          key="delete"
          data-method="post"
          data-confirm="Are you sure you want to delete this contract? This cannot be undone."
          className={
            className ||
            "block rounded-sm bg-transparent px-3 py-1 text-left text-red-700 no-underline hover:bg-blue-50 hover:text-blue-700"
          }
          href={this.props.deleteUrl}
        >
          Delete
        </a>
      )
    } else {
      if (this.props.quote.hasGroup) {
        actions.push(
          <a
            key="edit"
            className={
              className ||
              "block rounded-sm bg-transparent px-3 py-1 text-left text-black no-underline hover:bg-blue-50 hover:text-blue-700"
            }
            href={this.props.editUrl}
          >
            Edit
          </a>
        )
        if (this.props.quote.status !== "failed" && this.props.updatePolicy) {
          actions.push(
            <button
              key="send"
              className={
                className ||
                "block w-full rounded-sm bg-transparent px-3 py-1 text-left text-black no-underline hover:bg-blue-50 hover:text-blue-700"
              }
              type="button"
              onClick={this.openModal}
            >
              {this.sendButtonTitle()}
            </button>
          )
        }
        if (this.props.updatePolicy) {
          actions.push(
            <a
              key="preivewContract"
              className={
                className ||
                "block rounded-sm bg-transparent px-3 py-1 text-left text-black no-underline hover:bg-blue-50 hover:text-blue-700"
              }
              href={
                this.props.quote.withTemplate
                  ? this.props.savedPdfUrl
                  : this.props.generatePdfUrl
              }
              target="_blank"
              rel="noreferrer noopener"
            >
              Contract PDF
            </a>
          )
          actions.push(
            <a
              key="completeInHouse"
              className={
                className ||
                "block rounded-sm bg-transparent px-3 py-1 text-left text-black no-underline hover:bg-blue-50 hover:text-blue-700"
              }
              href={this.props.completeInHouseUrl}
            >
              Complete in house
            </a>
          )
          if (this.props.quote.status === "Sent") {
            actions.push(
              <button
                key="markAsDeclined"
                className={
                  className ||
                  "block w-full rounded-sm bg-transparent px-3 py-1 text-left text-black no-underline hover:bg-blue-50 hover:text-blue-700"
                }
                type="button"
                onClick={this.markContractDeclined}
              >
                Mark as declined
              </button>
            )
          }
          actions.push(
            <a
              key="expire"
              className={
                className ||
                "block rounded-sm bg-transparent px-3 py-1 text-left text-black no-underline hover:bg-blue-50 hover:text-blue-700"
              }
              data-toggle="tooltip"
              data-placement="bottom"
              title="Invalidates the contract so that it can't be signed."
              data-method="post"
              href={this.props.expireUrl}
            >
              Void
            </a>
          )
        }
      }
    }
    return actions
  }

  render() {
    const actionsList = this.actionsList()
    if (actionsList.length <= 1) {
      return (
        <div className="flex flex-col items-start">
          {this.actionsList(
            "bg-transparent text-blue-700 hover:underline py-1"
          )}
        </div>
      )
    }
    return (
      <div className="flex flex-col items-start" ref={this.setDropdownRef}>
        {this.state.showModal && (
          <Modal
            key="showModal"
            isOpen={true}
            onClose={this.closeModal}
            size="small"
          >
            <Modal.Header title="Confirm" />
            <Modal.Body>
              <p>
                Are you sure you want to send this quote? This will send the
                quote to the boater via email so they can sign and pay. This
                cannot be undone.
              </p>
            </Modal.Body>
            <Modal.Footer
              confirmBtnText={`${this.sendButtonTitle()} Contract`}
              confirmBtnLoading={this.state.saving}
              cancelBtnText="Cancel"
              onSubmit={this.sendContract}
              onClose={this.closeModal}
            />
          </Modal>
        )}
        <button
          className={classNames("bg-transparent px-0 py-1", {
            underline: this.state.dropdownShown,
            "text-blue-700": !this.state.saving,
            "hover:underline": !this.state.saving,
            "text-gray-600": this.state.saving,
          })}
          disabled={this.state.saving}
          type="button"
          onClick={this.toggleDropdown}
        >
          Actions
          <i className="fa-kit fa-chevron-down ml-1" />
        </button>
        {this.state.dropdownShown && (
          <div className="relative">
            <div
              className="absolute top-0 z-10 rounded bg-white p-2 shadow-lg"
              style={{
                minWidth: 165,
                transform: "translateX(calc(-100% + 65px))",
              }}
            >
              {actionsList}
            </div>
          </div>
        )}
      </div>
    )
  }
}

ContractQuoteV2Actions.propTypes = {
  quote: PropTypes.shape({
    encodedId: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
    hasGroup: PropTypes.bool,
    withTemplate: PropTypes.bool,
  }).isRequired,
  marina: PropTypes.shape({
    name: PropTypes.string,
    slug: PropTypes.string,
  }).isRequired,
  updatePolicy: PropTypes.bool,
  sendUrl: PropTypes.string,
  expireUrl: PropTypes.string,
  editUrl: PropTypes.string,
  completeInHouseUrl: PropTypes.string,
  markContractDeclinedUrl: PropTypes.string,
  deleteUrl: PropTypes.string,
  reservationUrl: PropTypes.string,
  generatePdfUrl: PropTypes.string,
  savedPdfUrl: PropTypes.string,
  updateSendContractFlash: PropTypes.func,
  markRowSending: PropTypes.func.isRequired,
}

export default ContractQuoteV2Actions
